import axios from 'axios';
import { API } from '../config';

class JustificativaService {
    getJustificativa(id) {
        return axios.get(API + `/justificativas/movimentos/${id}`)
    }
}

const instanceJustificativa= new JustificativaService();
export default instanceJustificativa;